import React, { useState } from 'react';
import MarketoForm from '../MarketoForm/MarketoForm';

const MarketoProfileForm = () => {
  const [submitted, setSubmitted] = useState(false);

  return (
    <div className="marketo_profile_form">
      <img
        src="https://assets.fastcompany.com/image/upload/v1679011502/fcweb/fc-newsletter-logo-small-2.svg"
        alt="plugged-in-newsletter-logo"
      />
      {submitted ? (
        <p>Thank you! Look out for Plugged In every Wednesday.</p>
      ) : (
        <React.Fragment>
          <p>Receive our free tech newsletter every Wednesday morning.</p>
          <MarketoForm
            assetId={1195}
            name="inline-profile-form"
            onSubmitHandler={setSubmitted}
          />
        </React.Fragment>
      )}
      <span>
        <a
          href="https://www.mansueto.com/privacy-policy/"
          title="Privacy Policy"
        >
          Privacy Policy
        </a>
      </span>
    </div>
  );
};

export default MarketoProfileForm;
